import { PRINTABLE_KIND, type PrintableKind } from "@bridewell/shared";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { weddingQuery } from "@bridewell/api-client";
import { PrintPage } from "@/features/print/print-page";

/**
 * /app/w/:weddingId/print/:kind — outside the app shell (the trailing `_` makes /app the parent, not the wedding
 * layout), so the page is just the printout. Still under /app: a session is required, and the API checks access.
 */
export const Route = createFileRoute("/app/w/$weddingId_/print/$kind")({
  beforeLoad: ({ params }) => {
    if (!(PRINTABLE_KIND as readonly string[]).includes(params.kind)) throw notFound();
  },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(weddingQuery(params.weddingId)),
  component: () => {
    const { kind } = Route.useParams();
    return <PrintPage kind={kind as PrintableKind} />;
  },
});
